// extracted by mini-css-extract-plugin
export default {"matchBox":"chatwith_matchBox__VRjq0","chatBox":"chatwith_chatBox__O7gtB","chatLayout":"chatwith_chatLayout__Nxk-5","matchContainer":"chatwith_matchContainer__w32Fo"};